module.exports = __webpack_public_path__ + "static/dashboard_intro5_en@2x-bca34a18dfc8311e2aae9e68208919fb.png";